<!-- <div class="topbar-layout flex flex-col ">
  <div class="columns-3 w-full">
    <div class="flex float-left order-first z-50">
      <div class="menu-icon-cointainer">
        <a class="menu-button cursor-pointer " (click)="togSide()">
          <i class="e-icons e-menu"></i>
        </a>
      </div>
      <div *ngIf="!isMobile" class="breadcrumbs-container ml-4 ">

        <app-bread-crumbs></app-bread-crumbs>
      </div>
    </div>






    <h1 class="text-xl flex flex-row justify-center content-center title">{{titolo}}</h1>

    <div *ngIf="isMobile && show" class="z-50">
      <a (click)="togSide()" class="cursor-pointer">
        <i class="e-icons e-close"></i>
      </a>
    </div>
    <div *ngIf="isMobile && !show" class="z-50">
      <a class="menu-button ">
        <i class="e-icons e-close invisible"></i>
      </a>
    </div>
    <div *ngIf="!isMobile" class="z-50">
      <a class="menu-button ">
        <i class="e-icons e-close invisible"></i>
      </a>
    </div>


  </div>

  <div *ngIf="isMobile" class="ml-4 mt-2">

    <app-bread-crumbs></app-bread-crumbs>
  </div>
</div> -->
<div *ngIf="!connectionStatus" class="sticky top-0 w-full bg-red-500 text-white text-center "
  style="z-index: 9999999999999999;">
  <p>Connessione assente</p>
</div>

<header class="topbar-layout flex justify-between p-2">
  <!-- breadcrumb desktop -->
  <!-- <div *ngIf="!isMobile" class="w-3/12 ">
      <div class="flex float-left order-first z-50">
        <div class="menu-icon-cointainer">
          <a class="menu-button cursor-pointer " (click)="togSide()">
            <i class="e-icons e-menu"></i>
          </a>
        </div>
        <div class="ml-2 overflow-auto">
          <ejs-breadcrumb [enableNavigation]="true" [url]="pageUrl" separatorTemplate=">" ></ejs-breadcrumb>
          <app-bread-crumbs></app-bread-crumbs>
        </div>
      </div>
    </div> -->

  <!-- breadcrumb mobile -->
  <div class="w-2/12 flex flex-col ">
    <div class="flex float-left order-first z-50">
      <div class="menu-icon-cointainer">
        <a class="menu-button cursor-pointer " (click)="togSide()">
          <i class="e-icons e-menu text-text"></i>
        </a>
      </div>
    </div>
  </div>

  <!-- title -->

  <div class="bg-transparent font-semibold align-top text-center w-8/12 text-text">
    <h3 class="font-bold text-lg lg:text-2xl ">{{titolo}}</h3>
  </div>

  <!-- exit --->

  <div class="w-2/12 ">
    <div class="flex flex-row justify-end">

      <!-- <svg class="w-8 h-8"
        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path
          d="M256 512h-64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h64a64 64 0 0 0 64-64V576a64 64 0 0 0-64-64z m0 320h-64V576h64zM514.53 832H480V384h64v151.06a256.78 256.78 0 0 1 64-52.53V384a64 64 0 0 0-64-64h-64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h64a63.39 63.39 0 0 0 19.41-3.32A256.56 256.56 0 0 1 514.53 832zM736 448a257.91 257.91 0 0 1 32 2.21V192h64v274.78a255.43 255.43 0 0 1 64 37.55V192a64 64 0 0 0-64-64h-64a64 64 0 0 0-64 64v258.21a257.91 257.91 0 0 1 32-2.21z" /><path
          d="M736 512c-106 0-192 86-192 192s86 192 192 192 192-86 192-192-86-192-192-192z m0.77 316.78a22.86 22.86 0 1 1 22.85-22.86 22.86 22.86 0 0 1-22.85 22.86z m18-96a19 19 0 0 1-37.89 0L712 625.05a24 24 0 1 1 48 0.05z" /></svg>
      <app-offline-api-list></app-offline-api-list> -->

      <!-- exit --->



      <button tabindex="0"
        class="text-primary-600 hover:text-white hover:bg-primary-500  p-2 rounded-2xl flex justify-center items-center gap-2 {{toRead>0 ? 'bg-amber-50 animate-pulse' : ''}}"
        (click)="showNotifs = !showNotifs;blockScroll()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10" />
          <path d="M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2" />
        </svg>
        <p class="rounded-full font-bold">{{toRead}}</p>
      </button>






      <!-- <div *ngIf="showRefreshData">
        <ejs-tooltip [target]="'#refresh-page-no-cache'" content="Carica i dati più recenti per le funzionalità offline"
          position="LeftCenter">
          <button id="refresh-page-no-cache" class="dl-button p-2 rounded-2xl" (click)="forceRefresh()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
          </button>
        </ejs-tooltip>
      </div> -->

    </div>
  </div>
</header>
<div class="z-50 w-full flex items-center justify-start gap-4" *ngIf="!isMobile">


  <button class="text-primary-600 hover:text-white flex rounded-full justify-center items-center " (click)="back()">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M9 14l-4 -4l4 -4" />
      <path d="M5 10h11a4 4 0 1 1 0 8h-1" />
    </svg>
  </button>
  <app-bread-crumbs></app-bread-crumbs>
</div>
<!-- sticky breadcrumb -->
<!-- <div class="z-50 px-4 py-1 top-0 backdrop-blur-2xl w-full sticky overflow-hidden">

  <app-bread-crumbs></app-bread-crumbs>
</div> -->



<div @slideDownUp *ngIf="showNotifs"
  class="card-danger bg-primary-950/40 backdrop-blur-lg rounded-none flex flex-col justify-start items-center min-h-screen max-h-screen w-screen overflow-scroll fixed top-0 left-0 "
  style="z-index: 100001;">



  <div class="flex flex-row justify-end w-full sticky top-0" style="z-index: 100001;">
    <button tabindex="0"
      class="text-primary-600 hover:text-white hover:bg-primary-500 bg-primary-50 p-2 rounded-2xl flex justify-center items-center gap-2 "
      (click)="showNotifs = false;blockScroll()" style="z-index: 56;">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6l-12 12" />
        <path d="M6 6l12 12" />
      </svg>
      <h4 class="rounded-full font-bold">{{toRead}}</h4>
    </button>
  </div>

  <app-notifications-center class="w-full lg:w-2/3 pb-24"></app-notifications-center>

</div>